import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SortContainer from './Sort/Container';

const PaymentsTable = ({ isLoading, access, items, handleSort, onChangeVisibility, handleChangeAllow, onEdit }) => {
  const handleSortEnd = ({ oldIndex, newIndex }) => {
    if (!access?.payments_sort) return;
    if (oldIndex !== newIndex) {
      handleSort({ oldIndex, newIndex });
    }
  };

  const handleSortStart = ({ node }, event) => {
    event.preventDefault();
    const tds = document.getElementsByClassName('on-drag')?.[0]?.childNodes;
    node?.childNodes?.forEach((node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`));
  };

  return (
    <div className="payments-list">
      <Table className="payments-sorttable">
        <thead>
          <tr>
            {access?.payments_sort ? <th className="payments-sorttable__head-handle"> </th> : null}
            <th className="payments-sorttable__head-method">Method</th>
            <th className="payments-sorttable__head-name">Name</th>
            <th className="payments-sorttable__head-min">Min</th>
            <th className="payments-sorttable__head-max">Max</th>
            <th className="payments-sorttable__head-new">New users</th>
            <th className="payments-sorttable__head-visibility">Visibility</th>
            <th className="payments-sorttable__head-actions"> </th>
          </tr>
        </thead>
        <SortContainer
          helperClass="on-drag"
          isLoading={isLoading}
          items={items}
          access={access}
          onSortStart={handleSortStart}
          onSortEnd={handleSortEnd}
          onChangeVisibility={onChangeVisibility}
          handleChangeAllow={handleChangeAllow}
          onEdit={onEdit}
          useDragHandle={access?.payments_sort}
        />
      </Table>
    </div>
  );
};

PaymentsTable.propTypes = {
  isLoading: PropTypes.bool,
  access: PropTypes.object,
  items: PropTypes.array,
  handleSort: PropTypes.func,
  onChangeVisibility: PropTypes.func,
  handleChangeAllow: PropTypes.func,
  onEdit: PropTypes.func,
};

export default PaymentsTable;
